import { Box, GridItem, Image, RadialLoader } from "@drone-js/core";
import type { FunctionComponent } from "react";

export interface PhotoUploadProps {
    src: string;
    percentage: number;
}

export const PhotoUpload: FunctionComponent<PhotoUploadProps> = ({ src, percentage }) => {
    return (
        <GridItem sm={6} md={4}>
            <Box width="100%" aspectRatio="1" position="relative" borderRadius="8" overflow="hidden">
                <Box
                    backgroundColor="base.overlay"
                    width="100%"
                    aspectRatio="1"
                    zIndex={3}
                    position="absolute"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <RadialLoader
                        label="loading"
                        size="m"
                        color="base.surface"
                        percentage={percentage >= 99 || percentage <= 1 ? undefined : percentage}
                    />
                </Box>
                <Image
                    alt="Property photo"
                    src={src}
                    srcSet={src}
                    width="100%"
                    aspectRatio="1"
                    objectFit="cover"
                    loading="lazy-blur"
                />
            </Box>
        </GridItem>
    );
};
